import React from "react";
import AppBar from "@material-ui/core/AppBar";
import { MenuList, MenuItem } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { auth } from "config/firebase";

const Navbar = () => {
  const { push } = useHistory();
  return (
    <AppBar style={{ marginBottom: "100px" }}>
      <MenuList
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "row"
        }}
      >
        {/* <MenuItem>Home</MenuItem> */}

        <MenuItem component={Link} to="/">
          Home
        </MenuItem>

        <MenuItem component={Link} to="/employee">
          Employee
        </MenuItem>
        <MenuItem
          onClick={e => {
            auth.signOut();
            push("/signin");
          }}
        >
          Log out
        </MenuItem>
      </MenuList>
    </AppBar>
  );
};

export default Navbar;
